/**
 * Componente: Confirmación de aprobar/rechazar una solicitud de
 * autorización de reimpresión. Mismo patrón que
 * ConfirmarAccionPersonalModal — reemplaza el confirm() nativo del
 * navegador, regla dura del proyecto.
 */

import React from 'react';
import { IconCerrar } from './icons';

const TEXTOS = {
  aprobar: (nombreContribuyente) => ({
    titulo: 'Autorizar reintento de impresión',
    mensaje: `¿Autorizar el reintento de impresión para ${nombreContribuyente}?`,
    nota: 'El operador va a poder reimprimir la credencial.',
    textoConfirmar: 'Autorizar',
    textoProcesando: 'Autorizando...',
    peligro: false,
  }),
  rechazar: (nombreContribuyente) => ({
    titulo: 'Rechazar solicitud',
    mensaje: `¿Rechazar el pedido de reimpresión para ${nombreContribuyente}?`,
    nota: 'El operador no va a poder reimprimir hasta que se genere una nueva solicitud.',
    textoConfirmar: 'Rechazar',
    textoProcesando: 'Rechazando...',
    peligro: true,
  }),
};

const ConfirmarSolicitudModal = ({ tipo, nombreContribuyente, procesando, onConfirmar, onCancelar }) => {
  const { titulo, mensaje, nota, textoConfirmar, textoProcesando, peligro } = TEXTOS[tipo](nombreContribuyente);

  return (
    <div className="modal-overlay">
      <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{titulo}</h2>
          <button className="modal-close" onClick={onCancelar} disabled={procesando}><IconCerrar size={18} /></button>
        </div>

        <div className="modal-body">
          <p>{mensaje}</p>
          {nota && <p className="form-hint">{nota}</p>}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancelar" onClick={onCancelar} disabled={procesando}>
            Cancelar
          </button>
          <button
            type="button"
            className={peligro ? 'btn-eliminar-confirmar' : 'btn-guardar'}
            onClick={onConfirmar}
            disabled={procesando}
          >
            {procesando ? textoProcesando : textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmarSolicitudModal;
